import {
  parseEnumFilter,
  parseNumberFilter,
  parseTextFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
} from '@/utils/filters';
import { INSTITUTE_STATUS, type InstituteStatus } from '../constants/institute.constants';

type FilterValues = Record<string, string>;

interface InstituteFilterSearch {
  instituteTypeId?: number | undefined;
  examBoardId?: number | undefined;
  divisionId?: number | undefined;
  districtId?: number | undefined;
  thanaId?: number | undefined;
  status?: InstituteStatus | undefined;
  eiinNumber?: string | undefined;
}

export function toInstituteFilterValues(search: InstituteFilterSearch): FilterValues {
  return {
    instituteTypeId: toFilterText(search.instituteTypeId),
    examBoardId: toFilterText(search.examBoardId),
    ...toGeoFilterValues(search),
    status: toFilterText(search.status),
    eiinNumber: toFilterText(search.eiinNumber),
  };
}

export function toInstituteFilterSearch(values: FilterValues): InstituteFilterSearch {
  return {
    instituteTypeId: parseNumberFilter(values.instituteTypeId),
    examBoardId: parseNumberFilter(values.examBoardId),
    ...toGeoSearch(values),
    status: parseEnumFilter(values.status, INSTITUTE_STATUS),
    eiinNumber: parseTextFilter(values.eiinNumber),
  };
}
